import React from 'react';
import HeadTittle from '../../../../components/HeadTittle';
import ButtonIcon from '../../../../components/buttons/ButtonIcon';
import { CleanIcon } from '../../../../components/buttons/IconButtons';
import { permissionObj } from '../../../../Helpers/permission';
import StepperTabs from "../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../components/StepperTabs/StepTab";
import { ButtonNextStep, ButtonPrevStep } from "../../../../components/buttons/ButtonNavigation";
import { STEPS_CREATE_FOODIE_SHIFT } from "./Model/Models";
import { CreateShiftApp } from "./Functionality/CreateShiftApp";
import SectionDiners from "./SubComponents/Steps/SectionDiners";
import SectionDepartments from "./SubComponents/Steps/SectionDepartments";
import SectionCustomAccess from "./SubComponents/Steps/SectionCustomAccess";
import Summary from "./SubComponents/Summary/Summary";

/**
 * @Author: Cecilia López Martínez / Arnulfo Ferro Zapata
 * @JobTitle : Full Stack Developer - IBL
 * Create foodie shift flow (stepper: diners → departments → custom access → summary).
 */
const CreateShift = () => {

    const {
        id,
        t,
        DEV,
        permission,
        emptyFields,
        disabled,
        item,
        handleChange,

        cafeterias, setCafeterias,
        selectDeleteCafeterias, setSelectDeleteCafeterias,

        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,

        user, setUser,
        selectDeleteUser, setSelectDeleteUser,

        steps,
        activeStep, setActiveStep,
        searchElement, setSearchElement,
        modified, setModified,
        handleStepChange,
        handleClearStep,
        handleValidateSteps,
        handleAddEdit,
        handleOnBack,
    } = CreateShiftApp();

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={'create'}/>

            <StepperTabs
                id={null}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_CREATE_FOODIE_SHIFT.DINERS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_FOODIE_SHIFT.DINERS.INDEX && (
                        <>
                            <SectionDiners
                                id={null}
                                item={item}
                                handleChange={handleChange}
                                emptyFields={emptyFields}
                                disabled={disabled}
                                handleClearStep={handleClearStep}
                                cafeterias={cafeterias}
                                setCafeterias={setCafeterias}
                                selectDeleteCafeterias={selectDeleteCafeterias}
                                setSelectDeleteCafeterias={setSelectDeleteCafeterias}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                modified={modified}
                                setModified={setModified}
                            />
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                <ButtonNextStep
                                    id='btn_cs_next_diners'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps(activeStep)) {
                                            setActiveStep((prev) => prev + 1);
                                        }
                                    }}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_FOODIE_SHIFT.DEPARTMENTS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_FOODIE_SHIFT.DEPARTMENTS.INDEX && (
                        <>
                            <SectionDepartments
                                id={null}
                                handleClearStep={handleClearStep}
                                departments={departments}
                                setDepartments={setDepartments}
                                selectDeleteDepartments={selectDeleteDepartments}
                                setSelectDeleteDepartments={setSelectDeleteDepartments}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                modified={modified}
                                setModified={setModified}
                            />
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_cs_back_departments'
                                    text='back'
                                    click={() => setActiveStep((prev) => prev - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cs_next_departments'
                                    text='next'
                                    click={() => setActiveStep((prev) => prev + 1)}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_FOODIE_SHIFT.CUSTOM_ACCESS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_FOODIE_SHIFT.CUSTOM_ACCESS.INDEX && (
                        <>
                            <SectionCustomAccess
                                id={null}
                                handleClearStep={handleClearStep}
                                user={user}
                                setUser={setUser}
                                selectDeleteUser={selectDeleteUser}
                                setSelectDeleteUser={setSelectDeleteUser}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                modified={modified}
                                setModified={setModified}
                            />
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_cs_back_custom_access'
                                    text='back'
                                    click={() => setActiveStep((prev) => prev - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cs_next_custom_access'
                                    text='next'
                                    click={() => setActiveStep((prev) => prev + 1)}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_FOODIE_SHIFT.SUMMARY.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_FOODIE_SHIFT.SUMMARY.INDEX && (
                        <>
                            <Summary
                                t={t}
                                item={item}
                                cafeterias={cafeterias}
                                departments={departments}
                                user={user}
                            />
                            <div className='d-flex justify-content-between px-0 mb-2 mt-3'>
                                <ButtonPrevStep
                                    id='btn_cs_back_summary'
                                    text='back'
                                    click={() => setActiveStep((prev) => prev - 1)}
                                />
                                {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_CREATE)) &&
                                    <ButtonNextStep
                                        id='btn_cs_create_shift'
                                        text='create'
                                        click={() => handleAddEdit()}
                                    />
                                }
                            </div>
                        </>
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
}

export default CreateShift
